export default (function textLengthLimiter(textArray, maxLength) {
  try {
    if (!Array.isArray(textArray)) {
      throw new Error('Input must be an array');
    }
    if (typeof maxLength !== 'number' || maxLength <= 0) {
      throw new Error('Max length must be a positive number');
    }
    textArray.forEach((text, i) => {
      try {
        let sentences = [];
        let sentence = "";
        const words = text.split(" ");
        for (let j = 0; j < words.length; j++) {
          if (sentence.length + words[j].length + 1 > maxLength) {
            sentences.push(sentence.trim());
            sentence = words[j];
          } else {
            sentence += " " + words[j];
          }
        }
        if (sentence.length > 0) {
          sentences.push(sentence.trim());
        }
        textArray[i] = sentences.shift();
        if (sentences.length > 0) {
          if (textArray[i + 1]) {
            textArray[i + 1] = sentences.join(" ") + " " + textArray[i + 1];
          } else {
            textArray.push(sentences.join(" "));
          }
        }
      } catch (err) {
        console.error(`Error processing text at index ${i}:`, err);
        // Preserve original text if there's an error
        return text;
      }
    });
    return textArray;
  } catch (err) {
    console.error('Error in textLengthLimiter:', err);
    return textArray; // Return original array on error
  }
});